/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { BrokerContactResponseDto } from './brokerContactResponseDto';
import type { BrokerProfileResponseDto } from './brokerProfileResponseDto';
import type { BrokerTenantResponseDto } from './brokerTenantResponseDto';

export interface BrokerResponseDto {
  id: string;
  /** @nullable */
  tenant: BrokerTenantResponseDto | null;
  contacts: BrokerContactResponseDto[];
  /** @nullable */
  profile: BrokerProfileResponseDto | null;
}
